export default {
  burberry: {
    title: {
      en: 'Burberry Cologne for Men',
    },
    metaTitle: {
      en: 'Burberry Cologne for Men - Try it for {price} - Scentbird',
    },
  },
  reviewsTitle: {
    default: {
      en: '{brandName} reviews',
    },
    burberry: {
      en: '{brandName} Cologne Reviews',
    },
    perfume: {
      en: '{brandName} Perfume Reviews',
    },
  },
  pageTopDescription: {
    en: `
      Want to try the most-popular Burberry colognes on the market? Scentbird gives you access for just
      {price} a month. Founded in 1856 by Thomas Burberry, the luxury British design house is known for
      its famed trench coat, and expanded into fragrances in 1981 with their Burberry for Men cologne.
      We’ve partnered with the label to sell their iconic scents on our platform — from classics like
      Burberry for Men, to trendy options like Burberry Brit Rhythm. Choose one for yourself, or pick
      a Burberry perfume as a gift, always authentic, delivered to you in an 8 ml vial.
    `,
  },
  pageBottomDescription: {
    en: `
      Join our community of 400,000+ subscribers who discover new designer scents every month such as
      our Burberry Cologne.
    `,
  },
}
